import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArticleIcon from '@mui/icons-material/Article';
import ShieldIcon from '@mui/icons-material/Shield';
import ScrollToTop from '../../../components/ScrollToTop';

const FAQS = [
    {
        question: 'How do I cancel my subscription?',
        answer: "You can cancel your subscription anytime from Account Settings → Cancel Subscription. Your access will continue until the end of your billing period.",
    },
    {
        question: 'Can I get a refund?',
        answer: "We offer refunds within 7 days of your first purchase if you're not satisfied. Contact our support team for assistance.",
    },
    {
        question: 'How do voice and video minutes work?',
        answer: "Voice and video minutes are included in your plan and reset each billing cycle. Unused minutes don't roll over to the next month.",
    },
    {
        question: 'Is my chat history private?',
        answer: "Absolutely. Your conversations are private and encrypted. You can delete your chat history anytime, and we never share your data with third parties.",
    },
    {
        question: 'How do I change my plan?',
        answer: "Go to Account Settings → Subscription to view and change your current plan. Upgrades take effect immediately, while downgrades apply at your next billing date.",
    },
    {
        question: 'What payment methods do you accept?',
        answer: "We accept Google Pay, PayPal, Cash App, and Venmo. All payments are processed securely.",
    },
];

export default function Help() {
    const navigator = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    const toggleFaq = (index) => {
        setOpenIndex((prev) => (prev === index ? -1 : index));
    };

    return (
        <>
            <Helmet>
                <title>Help | TLK</title>
            </Helmet>
            <ScrollToTop />
            {/* start: help page */}
            <div className="help-page">
                <header className="help-header">
                    <button className="help-back-btn" onClick={() => navigator(-1)}>
                        <ArrowBackIcon fontSize="small" />
                    </button>
                    <div className="help-title">
                        <span className="help-bar"></span>
                        <h1>Help &amp; Support</h1>
                    </div>
                </header>

                <main className="help-main">
                    <div className="help-content">

                        <div className="help-hero-card">
                            <h2>Need help?</h2>
                            <p>Our support team typically responds within 24 hours.</p>
                            <button type="button" className="help-contact-btn"
                                onClick={() => {
                                    window.location.href = "mailto:support@tlknow.ai";
                                }}
                            >
                                <MailOutlineIcon fontSize="small" />
                                Contact Support
                            </button>
                        </div>

                        <div className="help-faq-section">
                            <h3 className="help-section-label">Frequently Asked Questions</h3>
                            <div className="help-faq-list">
                                {FAQS.map((faq, index) => {
                                    const isOpen = openIndex === index;
                                    return (
                                        <div
                                            className={`help-faq-item ${isOpen ? 'active' : ''}`}
                                            key={faq.question}
                                        >
                                            <button
                                                type="button"
                                                className="help-faq-question"
                                                onClick={() => toggleFaq(index)}
                                                aria-expanded={isOpen}
                                            >
                                                <span>{faq.question}</span>
                                                <ExpandMoreIcon
                                                    fontSize="small"
                                                    className="help-faq-chevron"
                                                    style={{ transform: isOpen ? 'rotate(180deg)' : 'none' }}
                                                />
                                            </button>
                                            {isOpen && (
                                                <div className="help-faq-answer">
                                                    {faq.answer}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="help-quick-links">
                            <h3 className="help-section-label help-section-label-centered">Quick Links</h3>
                            <div className="help-quick-links-row">
                                <button onClick={() => navigator('/user/terms')}>
                                    <ArticleIcon fontSize="small" />
                                    Terms of Service
                                </button>
                                <button onClick={() => navigator('/user/privacy')}>
                                    <ShieldIcon fontSize="small" />
                                    Privacy Policy
                                </button>
                                <button className="help-quick-links-row"
                                    onClick={() => navigator('/community-guidelines')}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#ffffff"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-clipboard-check w-5 h-5 text-primary"
                                    >
                                        <rect width={8} height={4} x={8} y={2} rx={1} ry={1} />
                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                        <path d="m9 14 2 2 4-4" />
                                    </svg>
                                    Community Guidelines
                                </button>
                            </div>
                        </div>

                        {/* <div className="mt-8 text-center" style={{ opacity: 1 }}>
                            <p className="text-sm text-white mb-3">
                                Or just want to chat?
                            </p>
                            <button className="inline-flex items-center gap-2 text-primary font-medium">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-message-circle w-4 h-4"
                                >
                                    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                                </svg>
                                Talk to Reya
                            </button>
                        </div> */}
                    </div>
                </main>
            </div>
            {/* end: help page */}
        </>
    );
}